import Backbone from 'backbone';
import { on, off, getElement } from 'utils/mixins';
import Tools from '../../../services/Tools';
import BaseAPI from '../../../services/BaseAPI';

const ChatListView = require('../list/ChatListView');
const ChatListModel = require('../../../model/expand/list/ChatListModel');

var MobileDetect = require('mobile-detect');
const md = new MobileDetect(navigator.userAgent);
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',

  template() {
    const name = this.model.get('name');
    const email = this.model.get('email');
    const frame_name = this.conf.frame_name;
    const frame_email = this.conf.frame_email;
    const icon_dropdown = `${this.conf.domain}img/dropdown.svg`;
    var isShowSelectPage = false;
    if (this.conf.isShowDropDownSelectPage && this.conf.team.length > 0) {
      isShowSelectPage = true;
    }
    return `<div class="info-container">
            <div class="conversation"></div>
            ${
              isShowSelectPage
                ? `
              <div class="conten">
                  <label class="content-label mf">Nhóm nhân viên hỗ trợ</label>
                  <div class="dropdown">
                    <div class="dropbtn">
                      <div class="dropdown-label">${this.conf.team[0].name}</div>
                      <img src="${icon_dropdown}" style="margin-left: 10px;" />
                    </div>
                    <div class="dropdown-content"></div>
                  </div>
                  <div class="error_page error rf"></div>
              </div>
            `
                : ''
            }
            
            ${
              frame_name != 0
                ? `
              <div class="conten">
                  <label class="content-label mf">Họ và tên ${
                    frame_name == 2
                      ? `<span style="color:red;font-size: 12px">*</span>`
                      : ''
                  }</label>
                  <input autocomplete="off" class="infor_input fname mf" placeholder="Nhập họ và tên" maxlength="100" value="${name}" type="text" name="fname">
                  <div class="error_name error rf"></div>
              </div>
            `
                : ''
            }

            ${
              frame_email != 0
                ? `
              <div class="conten">
                  <label class="content-label mf">E-mail ${
                    frame_email == 2
                      ? `<span style="color:red;font-size: 12px">*</span>`
                      : ''
                  }</label>                        
                  <input autocomplete="off" class="infor_input email mf" placeholder="Nhập e-mail" maxlength="100" value="${email}" type="email" name="email">
                  <div class="error_email error rf"></div>
              </div>
            `
                : ''
            }

            <div class="conten_footer"></div>
            </div>
            <div class="info_button_container">
            </div>`;
  },

  initialize(o) {
    _.bindAll(
      this,
      'renderContent',
      'handleSaveClick',
      'handleSendClick',
      'validateToServer',
      'handleShowGreeting',
      'handleShowDropDown',
      'getListTeam',
      'handleSelectItem'
    );
    const model = this.model;
    model.view = this;
    this.conf = o.config || {};
    this.pfx = this.conf.stylePrefix || '';
  },

  handleSendClick(e) {
    const { $el, model } = this;
    const name = $el.find('.fname').val();
    const email = $el.find('.email').val();
    const message = $el.find('.message').val();
    model.trigger('saveClick', [name, email, message]);
  },

  handleShowGreeting(data) {
    const { $el, model, conf } = this;
    $el.find('.conversation').append(
      `<div class="avatar">
          <img src="${data.sender.avatar}"/>
        </div>
        <div class="message-inner message-supporter" >
          <div class="message-content">
            <div class="message_greeting" style="color:${conf.text_color_sup} ;background-color:${conf.background_color_sup}">
              ${data.message}
            </div>
          </div>
        </div>`
    );
  },

  handleSaveClick(e) {
    const { $el, model } = this;
    const frame_name = this.conf.frame_name;
    const frame_email = this.conf.frame_email;
    const frame_phone = this.conf.frame_phone;
    let name,
      email,
      phoneNumber = '';
    if (frame_name != 0) {
      name = $el.find('.fname').val();
    }
    if (frame_email != 0) {
      email = $el.find('.email').val();
    }
    if (frame_phone != 0) {
      phoneNumber = this.phoneNumberEl.val(); // $el.find('.phoneNumber').val();
    }

    $el.find('.txterror').remove();
    if (
      (!name && frame_name == 2) ||
      (!email && frame_email == 2) ||
      (!phoneNumber && frame_phone == 2)
    ) {
      if (!name && frame_name == 2) {
        $el
          .find('.error_name')
          .append(
            `<span class="txterror rf" style="color:red;font-size:12px">* Họ và tên không được phép để trống</span>`
          );
      }
      if (!email && frame_email == 2) {
        $el
          .find('.error_email')
          .append(
            `<span class="txterror rf" style="color:red;font-size:12px">* Email không được phép để trống.</span>`
          );
      }
      if (!phoneNumber && frame_phone == 2) {
        $el
          .find('.error_phone')
          .append(
            `<span class="txterror rf" style="color:red;font-size:12px">* Số điện thoại không được phép để trống.</span>`
          );
      }
      return false;
    }

    if (
      (frame_email != 0 &&
        email &&
        !Tools.validateEmail(email.toLowerCase())) ||
      (frame_phone != 0 &&
        phoneNumber &&
        (!Tools.validatePhone(phoneNumber.toLowerCase()) ||
          (phoneNumber.slice(0, 2) != 84 && phoneNumber.slice(0, 1) != 0)))
    ) {
      if (
        frame_email != 0 &&
        email &&
        !Tools.validateEmail(email.toLowerCase())
      ) {
        $el
          .find('.error_email')
          .append(
            `<span class="txterror" style="color:red;font-size:12px">* Email không đúng định dạng</span>`
          );
      }
      if (
        frame_phone != 0 &&
        phoneNumber &&
        (!Tools.validatePhone(phoneNumber.toLowerCase()) ||
          (phoneNumber.slice(0, 2) != 84 && phoneNumber.slice(0, 1) != 0))
      ) {
        $el
          .find('.error_phone')
          .append(
            `<span class="txterror" style="color:red;font-size: 12px">* Số điện thoại không đúng định dạng</span>`
          );
      }

      return false;
    }

    model.trigger('saveClick', {
      name: name,
      email: email,
      phoneNumber: phoneNumber
    });
  },

  validateToServer(error) {
    const { $el, model } = this;
    if (error.email) {
      $el
        .find('.error_email')
        .append(
          `<span class="txterror" style="color:red;font-size:12px">* ${error.email}</span>`
        );
    }
    if (error.phone) {
      $el
        .find('.error_phone')
        .append(
          `<span class="txterror" style="color:red;font-size:12px">* ${error.phone}</span>`
        );
    }
  },

  getListTeam() {
    const { conf } = this;
    var confix = {
      url: `${conf.domainSocial}/teams/list-team-chattool?page_social_id=${conf.domain_id}&social_type=7`,
      method: 'get',
      body: ''
    };
    var header = {
      'X-Merchant-ID': conf.merchant_id
    };
    BaseAPI.callAPI(
      confix,
      header,
      response => {
        if (response.data && response.data.length > 0) {
          conf.team = response.data;
          conf.teamID = response.data[0].id;
        }
        this.renderContent();
      },
      error => {
        this.renderContent();
      }
    );
  },

  handleSelectItem(event) {
    const { $el, conf } = this;
    $el
      .find('.dropdown-content')[0]
      .style.setProperty('display', 'none', 'important');
    $el.find('.dropbtn').css({
      'border-bottom-left-radius': '4px',
      'border-bottom-right-radius': '4px'
    });
    $el.find('.dropdown-content-name-check')[0].remove();
    const icon_selected_option = `${conf.domain}img/selected_option.svg`;
    const icon_dropdown = `${conf.domain}img/dropdown.svg`;
    conf.teamID = event.target.id;
    conf.team.forEach(element => {
      if (element.id === conf.teamID) {
        $el.find('.dropbtn').html(`<div class="dropdown-label">${element.name}</div><img src="${icon_dropdown}" style="margin-left: 10px;" />`);
        // $el.find('.dropbtn').append(`<img src="${icon_dropdown}" />`);
        $(event.target).append(
          `<img class="dropdown-content-name-check" src="${icon_selected_option}" />`
        );
        return;
      }
    });
  },

  handleShowDropDown(e) {
    e.stopPropagation();
    const { $el } = this;
    if ($el.find('.dropdown-content')[0].style.getPropertyValue('display') ===
      'block'
    ) {
      $el.find('.dropdown-content')[0].style.setProperty('display', 'none');
      $el.find('.dropbtn').css({
        'border-bottom-left-radius': '4px',
        'border-bottom-right-radius': '4px'
      });
      return;
    }
    $el.find('.dropdown-content')[0].style.setProperty('display', 'block');
    $el.find('.dropbtn').css({
      'border-bottom-left-radius': '0px',
      'border-bottom-right-radius': '0px'
    });
  },

  renderContent() {
    const { $el, model, conf } = this;
    const type = this.model.get('type');
    const phoneNumber = this.model.get('phoneNumber');
    const frame_phone = this.conf.frame_phone;

    $el.html(this.template());

    this.btnContainer = $el.find('.info_button_container');
    if (conf.isShowDropDownSelectPage && conf.team.length > 0) {
      const icon_selected_option = `${conf.domain}img/selected_option.svg`;
      conf.team.forEach((element, i) => {
        $el.find('.dropdown-content').append(
          `<div id="${element.id}" class="dropdown-content-select">
              ${element.name}
              ${
                i === 0
                  ? `<img class="dropdown-content-name-check" src="${icon_selected_option}" />`
                  : ''
              }
            </div>`
        );
      });
    }
    $el.find('.dropdown-content-select').on('click', this.handleSelectItem);

    if (type == 1) {
      if (frame_phone != 0) {
        $el.find('.conten_footer').append(`
          <label class="content-label mf">Số điện thoại ${
            frame_phone == 2
              ? `<span style="color:red;font-size: 12px">*</span>`
              : ''
          }</label>                        
          <input autocomplete="off" class="infor_input phoneNumber mf" placeholder="Nhập số điện thoại" value="${phoneNumber}" type="tel" name="phoneNumber">
          <div class="error_phone error mf"></div>
        `);
      }
      this.btnContainer.append(
        `<button style="background-color:${conf.header_color};color:${conf.text_header_color};cursor: pointer;" class="save_button save bf" >Bắt đầu chat</button>`
      );
    } else {
      $el.find('.conten_footer').append(`
                <label>Tin nhắn</label>                        
                <textarea name="message" class="message" placeholder="Nhập tin nhắn ..."></textarea>
            `);
      $el
        .find('.info_button_container')
        .append(
          `<button style="background-color:${conf.header_color};color:${conf.text_header_color}" class="save_button send bf" >Gửi</button>`
        );
    }
    $el.find('.fname').on('keyup', function(e) {
      $el.find('.txterror').remove();
    });
    $el.find('.email').on('keyup', function(e) {
      $el.find('.txterror').remove();
    });
    this.phoneNumberEl = $el.find('.phoneNumber');
    this.phoneNumberEl.on('keyup', function(e) {
      var val = $(this).val() || '';
      var number = val.match(/\d/g);
      if (number) {
        number = number.join('');
        $(this).val(number);
      } else {
        $(this).val('');
      }
      $el.find('.txterror').remove();
    });
    $el.find('.cancel').on('click', this.handlecancelClick);
    $el.find('.save').on('click', this.handleSaveClick);
    $el.find('.send').on('click', this.handleSendClick);
    $el.find('.dropbtn').on('click', this.handleShowDropDown);
    $el.find('.dropdown-label').on('click', this.handleShowDropDown);

    const body = conf.canvas.frameBody;
    body.on('click', function(evt) {
      var target = evt.target.className;
      if (
        target != 'dropbtn' &&
        target != 'dropdown-content-select' &&
        $el.find('.dropdown')
      ) {
        $el.find('.dropdown-content')[0] && $el.find('.dropdown-content')[0].style.setProperty('display', 'none');
        $el.find('.dropbtn').css({
          'border-bottom-left-radius': '4px',
          'border-bottom-right-radius': '4px'
        });
      }
    });
    if (md.mobile()) {
      $el.find('.infor_input').css({ height: '40px' });
    }
  },

  render() {
    const { $el, model } = this;
    $el.attr({ class: `${this.pfx}myModal`, id: 'myModal' });
    this.getListTeam();
    return this;
  }
});
